import React from 'react';

function Copy01Icon({ fill, ...restProps }) {
  return (
    <svg
      fill={fill ?? ''}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M3.749 1.045c-.782.075-1.347.326-1.859.825-.399.39-.654.861-.796 1.47-.07.303-.074.584-.074 5.2v4.88l.09.34c.285 1.076 1.049 1.846 2.11 2.125.387.102 1.765.155 2.044.08.234-.064.473-.251.603-.473.097-.165.113-.235.113-.492 0-.254-.017-.328-.108-.484a1.113 1.113 0 0 0-.499-.442c-.062-.025-.459-.059-.881-.075-.854-.033-1.023-.079-1.237-.332-.251-.298-.235.052-.235-5.127 0-3.781.01-4.755.052-4.894.07-.228.346-.504.574-.574.139-.042 1.113-.052 4.894-.052h4.72l.18.094c.238.124.329.212.434.423.077.154.091.27.119.976.031.793.032.802.15.994a.999.999 0 0 0 1.716-.004l.121-.197-.004-.883c-.003-.774-.014-.922-.09-1.201-.234-.856-.75-1.496-1.515-1.879-.356-.178-.629-.254-1.091-.302-.465-.048-9.023-.045-9.531.004m7 7c-.782.075-1.347.326-1.859.825-.399.39-.654.861-.796 1.47-.07.303-.074.584-.074 5.18v4.86l.091.355c.17.671.526 1.227 1.031 1.615a2.86 2.86 0 0 0 1.123.539l.355.091h4.86c4.596 0 4.877-.004 5.18-.074.799-.186 1.381-.579 1.826-1.235.199-.293.321-.587.42-1.011.07-.303.074-.583.074-5.16s-.004-4.857-.074-5.16c-.218-.936-.739-1.603-1.577-2.019-.31-.153-.623-.23-1.149-.279-.531-.051-8.907-.048-9.431.003m9.625 2.03c.211.07.488.356.554.571.077.256.077 9.452 0 9.708-.065.213-.337.495-.552.571-.232.082-9.52.082-9.752 0-.202-.071-.484-.354-.549-.551-.067-.199-.101-8.859-.038-9.425.065-.584.304-.845.829-.908.151-.017 2.317-.029 4.814-.025 3.577.006 4.573.018 4.694.059'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default Copy01Icon;
